/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <GlobalGraph class="graph" v-if="series.length" :graphID="title" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :title="graphTitle" :theme="theme" :loading="loading" />
</template>

<script>
import GlobalGraph from '@/components/common/GlobalGraph'
import { mapGetters } from 'vuex'

export default {
  components: {
    GlobalGraph
  },
  props: ['series', 'xAxis', 'title', 'theme'],
  data() {
    return {
      loading: false,
      yAxis: [
        {
          type: 'value',
          name: '',
          min: 0,
          position: 'left',
          axisLabel: {
            formatter: '{value}',
            rotate: 20
          }
        }
      ],
      graphTitle: {}
    }
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    currentLanguage() {
      return this.getGeneralState('language')
    }
  },
  created() {
    switch (this.title) {
      case 'irradiance_vertical':
        this.$set(this.graphTitle, 'text', this.$t('Irradiance PoA'))
        this.yAxis[0].name = `${this.$t('PoA')} (W/m²)`
        break
      case 'irradiance_horizontal':
        this.$set(this.graphTitle, 'text', this.$t('Irradiance GHI'))
        this.yAxis[0].name = `${this.$t('GHI')} (W/m²)`
        break
      case 'module_temp':
        this.$set(this.graphTitle, 'text', this.$t('Module Temperature'))
        this.yAxis[0].name = `${this.$t('Module Temperature')} (°C)`
        break
      case 'ambient_temp':
        this.$set(this.graphTitle, 'text', this.$t('Ambient Temperature'))
        this.yAxis[0].name = `${this.$t('Ambient Temperature')} (°C)`
        break
      case 'wind_speed':
        this.$set(this.graphTitle, 'text', this.$t('Wind Speed'))
        this.yAxis[0].name = 'wind speed (m/s)'
        break
      case 'direction':
        this.$set(this.graphTitle, 'text', this.$t('Wind Direction'))
        this.yAxis[0].name = `${this.$t('Wind Direction')} (°)`
        break
      case 'rain_gauge':
        this.$set(this.graphTitle, 'text', this.$t('Rain'))
        this.yAxis[0].name = `${this.$t('Rain')} (mm)`
        break
      case 'humidity':
        this.$set(this.graphTitle, 'text', this.$t('Humidity'))
        this.yAxis[0].name = `${this.$t('Humidity')} (%)`
        break
      case 'radiation':
        this.$set(this.graphTitle, 'text', this.$t('Radiation'))
        this.yAxis[0].name = `${this.$t('Radiation')} (W/m²)`
        break
      case 'pressure':
        this.$set(this.graphTitle, 'text', this.$t('Pressure'))
        this.yAxis[0].name = `${this.$t('Pressure')} (hPa)`
        break
    }
    this.$set(this.graphTitle, 'left', 'center')
  },
  watch: {
    currentLanguage() {
      switch (this.title) {
        case 'irradiance_vertical':
          this.$set(this.graphTitle, 'text', this.$t('Irradiance PoA'))
          this.yAxis[0].name = `${this.$t('PoA')} (W/m²)`
          break
        case 'irradiance_horizontal':
          this.$set(this.graphTitle, 'text', this.$t('Irradiance GHI'))
          this.yAxis[0].name = `${this.$t('GHI')} (W/m²)`
          break
        case 'module_temp':
          this.$set(this.graphTitle, 'text', this.$t('Module Temperature'))
          this.yAxis[0].name = `${this.$t('Module Temperature')} (°C)`
          break
        case 'ambient_temp':
          this.$set(this.graphTitle, 'text', this.$t('Ambient Temperature'))
          this.yAxis[0].name = `${this.$t('Ambient Temperature')} (°C)`
          break
        case 'wind_speed':
          this.$set(this.graphTitle, 'text', this.$t('Wind Speed'))
          this.yAxis[0].name = 'wind speed (m/s)'
          break
        case 'direction':
          this.$set(this.graphTitle, 'text', this.$t('Wind Direction'))
          this.yAxis[0].name = `${this.$t('Wind Speed')} (°)`
          break
        case 'rain_gauge':
          this.$set(this.graphTitle, 'text', this.$t('Rain'))
          this.yAxis[0].name = `${this.$t('Rain')} (mm)`
          break
        case 'humidity':
          this.$set(this.graphTitle, 'text', this.$t('Humidity'))
          this.yAxis[0].name = `${this.$t('Humidity')} (%)`
          break
        case 'radiation':
          this.$set(this.graphTitle, 'text', this.$t('Radiation'))
          this.yAxis[0].name = `${this.$t('Radiation')} (W/m²)`
          break
        case 'pressure':
          this.$set(this.graphTitle, 'text', this.$t('Pressure'))
          this.yAxis[0].name = `${this.$t('Pressure')} (hPa)`
          break
      }
    }
  }
}
</script>

<style scoped>
.graph {
  width: 100%;
  height: 250px;
}
</style>
